import { HIDE_RELATED_LINKS } from '../../../../util/constants';

const ALERT_ROWS = ['header-alert-1', 'header-alert-2', 'header-alert-3'];
const LINK_ROWS = ['header-link-1', 'header-link-2', 'header-link-3'];
const TILE_KEYS = ['header-tile-1', 'header-tile-2', 'header-tile-3'];
const OVERVIEW_ROWS = [
  'header-overview-1',
  'header-overview-2',
  'header-overview-3',
  'header-overview-4',
];

const CheckboxPlaceholder = () => (
  <span
    className="placeholder rounded-1 flex-shrink-0"
    style={{ width: 16, height: 16 }}
  />
);

/** Yellow-region chrome: title, actions, related cards, tiles, overview. */
const ReportHeaderSkeleton = () => (
  <div className="placeholder-glow">
    <div className="d-flex flex-column d-sm-block">
      <div className="float-sm-end ao_secondaryBtnGroup order-3 mt-0 mb-2">
        <div className="d-inline-flex align-items-center gap-2">
          <span
            className="placeholder rounded"
            style={{ width: 110, height: 36 }}
          />
          <span
            className="placeholder rounded"
            style={{ width: 100, height: 36 }}
          />
        </div>
      </div>

      <h1 className="Garamond fw-semibold v3-heading mb-2">
        <span className="placeholder rounded col-4" style={{ height: '2rem' }} />
      </h1>

      <p className="ao_showSource mt-2 mb-1">
        <span className="placeholder rounded col-3" style={{ height: '0.9rem' }} />
      </p>
    </div>

    <div className="row p-0 m-0 gx-3 w-100 d-flex">
      <div
        className={
          HIDE_RELATED_LINKS ? 'p-0 col-12 mt-3 d-flex' : 'ps-0 col-md-9 mt-4 d-flex'
        }
      >
        <div className="v3-report-content-card w-100">
          <div className="mb-3">
            <span
              className="placeholder rounded"
              style={{ width: 120, height: '1rem' }}
            />
          </div>
          {ALERT_ROWS.map((key) => (
            <div className="d-flex align-items-start gap-2 mb-2" key={key}>
              <CheckboxPlaceholder />
              <div className="flex-grow-1">
                <span className="placeholder rounded col-10 d-block mb-1" />
                <span
                  className="placeholder rounded col-3 d-block"
                  style={{ height: '0.75rem' }}
                />
              </div>
              <span
                className="placeholder rounded-circle flex-shrink-0"
                style={{ width: 18, height: 18 }}
              />
            </div>
          ))}
        </div>
      </div>
      {!HIDE_RELATED_LINKS && (
        <div className="col-md-3 mt-4 d-flex pe-0">
          <div className="v3-report-content-card w-100">
            <div className="mb-3">
              <span
                className="placeholder rounded"
                style={{ width: 100, height: '1rem' }}
              />
            </div>
            {LINK_ROWS.map((key) => (
              <div className="mb-2" key={key}>
                <span className="placeholder rounded col-11" />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>

    <div className="ao_primaryBtnGroup mt-3 d-flex flex-wrap gap-2">
      {TILE_KEYS.map((key) => (
        <span
          key={key}
          className="placeholder rounded"
          style={{ width: 150, height: 36 }}
        />
      ))}
    </div>

    <div id="overviewMainBox" className="v3-report-content-card mt-4">
      {OVERVIEW_ROWS.map((key) => (
        <div className="row align-items-start mb-2" key={key}>
          <div className="col-md-4">
            <span
              className="placeholder rounded col-6"
              style={{ height: '0.95rem' }}
            />
          </div>
          <div className="col-md-8">
            <span className="placeholder rounded col-11 mb-1 d-block" />
            <span className="placeholder rounded col-8 d-block" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ReportHeaderSkeleton;
